<template>
  <InlineActionConfirmation
    :disabled="changesAreDisabled"
    @confirm="emit('deleteAttachment')"
  >
    <template #default="{ openConfirmation }">
      <div class="tw-flex">
        <SfButtonDs
          variant="tertiary"
          size="sm"
          icon-only
          icon-before="download"
          :aria-label="I18n.t('file_attachments_sidebar.actions.download')"
          @click="handleDownload"
        />
        <SfButtonDs
          v-if="!isMsgAttachment"
          variant="tertiary"
          size="sm"
          icon-only
          icon-before="external-link-alt"
          :aria-label="I18n.t('file_attachments_sidebar.actions.preview')"
          @click="handlePreview"
        />
        <SfButtonDs
          v-if="showDeleteButton"
          variant="tertiary"
          size="sm"
          icon-only
          icon-before="trash"
          class="hover:tw-text-sf-danger-light-1"
          :aria-label="I18n.t('file_attachments_sidebar.actions.delete')"
          @click="openConfirmation"
        />
      </div>
    </template>
  </InlineActionConfirmation>
</template>

<script setup lang="ts">
import type { Attachment } from './types'

import { computed } from 'vue'

import { SfButtonDs } from '@silverfin/ui-components'
import useI18n from '@app/shared/vue/composables/use-I18n'
import InlineActionConfirmation from '@app/shared/vue/components/molecules/inline-action-confirmation/inline-action-confirmation.vue'
import {
  previewAttachment,
  downloadAttachment,
} from '@app/utils/attachment-helpers'

interface Props {
  attachment: Attachment
  changesAreDisabled: boolean
  showDeleteButton?: boolean
}

const { attachment, showDeleteButton = true } = defineProps<Props>()

const I18n = useI18n()

// .msg files are previewed inline via multi-tab PDFTron in the side-by-side
// viewer. The "open in new tab" affordance would route to the legacy
// /permanent_mails/:id page which is now redundant.
const isMsgAttachment = computed(() =>
  attachment.name?.toLowerCase().endsWith('.msg')
)

const emit =
  defineEmits<{
    deleteAttachment: []
  }>()

function handleDownload(): void {
  downloadAttachment(attachment.document_id.toString())
}

function handlePreview(): void {
  previewAttachment(attachment.document_id.toString())
}
</script>
